
import Navigation from '../components/utils/Navigation';
import NoDataAvailable from "../components/utils/NoDataAvailable.vue";
import { waitSeconds } from '../utils/utilitiesmodule';
export default {
    name: "Users",
    props: {
        idGroup: String
    },
    components: {
        Navigation,
        NoDataAvailable,
    },
    watch: {
        '$route': {
            handler: async function(to) {
                try {
                    var idUser, user;

                    if (to.hash==""||to.name!="users") {
                        return;
                    }

                    if (this.users==null) {
                        await this.getUsers(false);
                    }

                    if (to.hash.endsWith("/delete")) {
                        idUser=to.hash.split("/")[0].replace("#", "");
                        user=this.users.find((user) => user.id==idUser);
                        this.deleteUser(user);
                        return;
                    }

                    idUser=to.hash.replace("#", "");
                    this.openDialogUser(idUser);

                } catch (e) {
                    console.writeError(e);
                    this.$router.removeHash();
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            users: null,
            checkTFA: {
                step1: null,
                step2: null
            },
            filters: {
                strToSearch: "",
                role: "",
                mfa_enabled: 'show_all'
            },
            treeViewHtml: "",
            filteredusers: [],
            idUserLogged: this.$root.authObj.id_user
        }
    },
    computed: {
        userEmail() {
            return this.$root.authObj.email;
        },
    },
    mounted: async function() {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        if (this.$root.checkAuth()) {
            this.getUsers(false);
        }
        this.$root.$on("refreshUsers", () => this.getUsers(false));
    },


    methods: {
        async getUsers(applyFilters) {
            let self=this;

            if (!applyFilters) {
                self.$api.getUsers().then(async list => {
                    if (!self.users) {
                        self.users=[]
                    }
                    if (self.users) {
                        self.users.clear();
                        await waitSeconds(0.1);
                    }
                    self.users.update(list);
                    self.$session.setUsers(self.users);
                });
                return;
            }

            self.users.update(this.$session.getUsers().filter(user => {
                var f1=(
                    this.filters.strToSearch==''||
                    user.username.contains(this.filters.strToSearch)||
                    user.firstname.contains(this.filters.strToSearch)||
                    user.lastname.contains(this.filters.strToSearch)
                );
                var f2=['', user.role].includes(this.filters.role);
                var f3=['show_all', user.mfa_enabled].includes(this.filters.mfa_enabled);
                console.log(f1 + " " + f2 + " " + f3)
                return f1&&f2&&f3;
            }));


        },
        async openDialogUser(userID) {
            var user=await this.$api.getUser(userID);
            this.$root.$emit("OPENUSERVIEWDIALOG", user, this.checkTFA);
        },

        async deleteUser(user) {
            //Personalizzo la dialog da mostrare
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            var dialogTitle=this.$t("Delete User");
            var dialogContent=this.$t('deleteConfirmation', { 0: user.username });

            let self=this;
            this.$root.$on(dialogID, async ok => {
                if (ok) {
                    ok=await self.$api.deleteUser(user.id, user.username);
                }
                self.$router.removeHash();
                self.$root.$off(dialogID);
                if (ok) {
                    self.$root.$emit("refreshUsers");
                }

            });

            //Avvio la richiesta che mi risponderà con un $emit
            this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent)
        }

    }
}